import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  const { theme = "light" } = useTheme()

  return (
    <Sonner
      theme={theme === "dark" ? "dark" : "light"}
      richColors
      closeButton
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "bg-white !text-slate-950 border border-slate-200 shadow-xl rounded-xl px-4 py-3 [&_[data-title]]:!text-slate-950 [&_[data-description]]:!text-slate-800",

          title:
            "!text-slate-950 font-semibold",

          description:
            "!text-slate-800",

          actionButton:
            "bg-blue-600 !text-white",

          cancelButton:
            "bg-slate-200 !text-slate-900",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }